import styles from "./PromoBox.module.scss";
import { Header_Startseite } from "@/wp/types/acf-header-types";
import { Button } from "@/components/Button/Button";
import { removeExtraSpacesFromClassNames } from "@/utils/removeExtraSpacesFromClassNames";
import Image from "next/image";
import { CustomSVG } from "@/components/_primitives/CustomSVG/CustomSVG";
import { ContentTag } from "@/components/ContentTag/ContentTag";

interface PromoBoxProps {
  promobox: Header_Startseite["header_startseite"]["promobox"];
}

export const PromoBox = ({ promobox }: PromoBoxProps) => {
  const { show_promobox, hintergrundfarbe, logo, image, text, link } = promobox;

  // Don't render if promobox is disabled
  if (!show_promobox) {
    return null;
  }

  const containerClass = removeExtraSpacesFromClassNames(
    `${styles["promo-box"]} is-box`,
  );

  // Get link data
  const linkUrl = link && typeof link === "object" ? link.url : "";
  const linkTitle = link && typeof link === "object" ? link.title : "";
  const linkTarget =
    link && typeof link === "object" ? link.target || "_self" : "_self";

  return (
    <div
      className={containerClass}
      style={
        {
          "--promo-box-bg": hintergrundfarbe || "#000d41",
        } as React.CSSProperties
      }
    >
      <div className={styles["promo-box-content"]}>
        {/* Left side: Logo, Text, Button */}
        <div className={styles["promo-box-text-wrapper"]}>
          {logo && (
            <div className={styles["promo-box-logo"]}>
              <CustomSVG src={logo.url} alt={logo.alt || ""} />
            </div>
          )}

          {text && (
            <ContentTag
              extraClass={styles["promo-box-text"]}
              content={text}
              disablePaddingBottom
            />
          )}

          {linkUrl && (
            <Button
              type="secondary"
              href={linkUrl}
              target={linkTarget}
              invert
              className={`${styles["promo-box-button"]} mb-0 mt-3`}
            >
              {linkTitle}
            </Button>
          )}
        </div>

        {/* Right side: Gold bars image */}
        {image && (
          <div className={styles["promo-box-image"]}>
            <Image
              src={image.url}
              alt={image.alt || ""}
              width={image.width}
              height={image.height}
              sizes="(max-width: 767px) 50vw, (max-width: 1023px) 50vw, 320px"
            />
          </div>
        )}
      </div>
    </div>
  );
};
